import _classCallCheck from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { vgField } from '../../channeldef';
import { duplicate, hash as _hash } from '../../util';
import { unique } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for the join aggregate transform nodes.
 */

export var JoinAggregateTransformNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(JoinAggregateTransformNode, _DataFlowNode);

  var _super = _createSuper(JoinAggregateTransformNode);

  function JoinAggregateTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, JoinAggregateTransformNode);

    _this = _super.call(this, parent);
    _this.transform = transform;
    return _this;
  }

  _createClass(JoinAggregateTransformNode, [{
    key: "clone",
    value: function clone() {
      return new JoinAggregateTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      this.transform.groupby = unique(this.transform.groupby.concat(fields), function (d) {
        return d;
      });
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var out = new Set();

      if (this.transform.groupby) {
        this.transform.groupby.forEach(out.add, out);
      }

      this.transform.joinaggregate.map(function (w) {
        return w.field;
      }).filter(function (f) {
        return f !== undefined;
      }).forEach(out.add, out);
      return out;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.joinaggregate.map(this.getDefaultName));
    }
  }, {
    key: "getDefaultName",
    value: function getDefaultName(joinAggregateFieldDef) {
      var _a;

      return (_a = joinAggregateFieldDef.as) !== null && _a !== void 0 ? _a : vgField(joinAggregateFieldDef);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "JoinAggregateTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var fields = [];
      var ops = [];
      var as = [];

      var _iterator = _createForOfIteratorHelper(this.transform.joinaggregate),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var joinaggregate = _step.value;
          ops.push(joinaggregate.op);
          as.push(this.getDefaultName(joinaggregate));
          fields.push(joinaggregate.field === undefined ? null : joinaggregate.field);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var groupby = this.transform.groupby;
      return Object.assign({
        type: 'joinaggregate',
        as: as,
        ops: ops,
        fields: fields
      }, groupby !== undefined ? {
        groupby: groupby
      } : {});
    }
  }]);

  return JoinAggregateTransformNode;
}(DataFlowNode);